import React, { FunctionComponent, useEffect, useState, useCallback } from 'react';
import Container from '@material-ui/core/Container';
import { data } from './local';
import { Avatar, Button, createStyles, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, InputLabel, makeStyles, Menu, MenuItem, Paper, Select, StepLabel, styled, Table, TableBody, TableCell, TableHead, TableRow, Theme } from '@material-ui/core';
import TableContainer from '@mui/material/TableContainer';
import { eventEmitter, getNominatorMail, getToken, getUserGraphId, getUserInfo } from './common';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { addAwardeeDetails, getAwardeeList } from './services';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { appInsights } from '../AppInsights';
import DeleteIcon from '@mui/icons-material/Delete';
import { NotificationAlert } from "./NotificationAlert";
import ReactDOM from 'react-dom'
import Cropper from 'react-easy-crop'
import Slider from '@material-ui/core/Slider'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import ImgDialog from '../helpers/ImpDialog'
import getCroppedImg from '../helpers/cropImage'
import { containerClasses } from '@mui/material';

import styles from "./Common.module.scss";
const AddAwardee: FunctionComponent<any> = () => {
  
  const [Imagestate, setImageState] = React.useState(false);
  let history: any = useHistory();
  const [count, Setcount] = useState(0);
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState<any>('');
  const [alertType, setAlertType] = useState<any>('');

  const getcorrelationId = () => {
    return sessionStorage.getItem("correlationId");
  }

  const classes = useStyles();
  var awardeeList: any;
  useEffect(() => {
    getAwardeeList().then((response: any) => {

      if (response != null) {
        let ListOfAwardees = [];
        for (let key in response) {
          ListOfAwardees.push({
            id: key, awardeeName: response[key].awardeeName, awardedOn: response[key].awardedOn,
            videoLink: response[key].videoLink, location: response[key].location,
            organization: response[key].organization, picture: response[key].imageId
          });
        }
        if (ListOfAwardees.length > 0) {
          awardeeList = ListOfAwardees;
          setUpdatedAwardeeList(awardeeList);
        }
      }
    });
  }, [count])
  const columns: GridColDef[] = [

    { field: 'id', headerName: 'ID', hide: true },
    { field: 'awardeeName', headerName: 'Name', minWidth: 150, flex: 1 },
    { field: 'organization', headerName: 'Organization', minWidth: 150, flex: 1 },
    { field: 'location', headerName: 'Location', minWidth: 150, flex: 1 },
    { field: 'awardedOn', headerName: 'AwardedOn', minWidth: 150, flex: 1 },
    {
      field: 'picture', headerName: 'Picture', minWidth: 100, flex: 1, renderCell: (params) => {
        return (
          <>
            <Avatar src={params.row.picture} alt={params.row.awardeeName} style={{ width: 50, height: 50 }}/>
          </>
        );
      }
    },
    {
      field: 'videoLink', headerName: 'VideoURL', minWidth: 150, flex: 1, renderCell: (params) => {
        return (
          <>
            <span style={{ color: "#3f51b5", cursor: "pointer" }} onMouseDown={() => {
              window.open(params.row.videoLink)
            }} >
              {params.row.videoLink}
            </span>
          </>
        );
      }
    },
    { field: 'Notes', headerName: 'Notes', minWidth: 150, flex: 1 },
  ]
  const handleFileChange = (event: any) => {
    const maxSize = 2000000;
    const [file] = event.target.files;
if(file!=null){
  if (file.size <= maxSize) {
    setImageState(true);
    setImageDetails(event.target.files[0].name);
    setPictureDetails(event.target.files[0]);
    setUploadedImage(URL.createObjectURL(event.target.files[0]));
    setCancelIcon(true);
  } else {
    setopenImageSizeAlert(true);
  }
}
  }

  const handleShowDialog = () => {
    setImageState(!Imagestate);
}

   /*New code*/
   const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [rotation, setRotation] = useState<number>(0)
  const [zoom, setZoom] = useState<number | string | Array<number | string>>(1,)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
  const [croppedImage, setCroppedImage] = useState(null)

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }, [])

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        UploadedImage,
        croppedAreaPixels,
        rotation
      )
      let ImageBlob:any=URL.createObjectURL(croppedImage);
      setCroppedImage(ImageBlob);
    } catch (e) {
      console.error(e)
    }
  }, [croppedAreaPixels, rotation])

  const saveCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        UploadedImage,
        croppedAreaPixels,
        rotation
      )
      if(imageDetails!=undefined){
        let blobImg:Blob=croppedImage;
        let BlobPart:any=blobImg.stream;
        let file = new File([croppedImage], imageDetails);
        let finalFile:any=file;
              setPictureUrl(finalFile);
              setImageState(!Imagestate);
      }

    } catch (e) {
      console.error(e)
    }
  }, [croppedAreaPixels, rotation])

  const onClose = useCallback(() => {
    setCroppedImage(null)
  }, [])

  const handleZoom = (event: React.ChangeEvent<{}>, newValue: number | number[]) => {
    setZoom(newValue);
  };
   /*New Code Ends*/

  const setPictureURLValue = () => {
    setCancelIcon(false);
    setPictureUrl('');
    setImageDetails(undefined);
  }

  //  const languageSelected:any = useSelector((state:any) => state.lang);
  const languageSelected: any = useSelector((state: any) => state.lang);
  const languageData: any = data;
  const { VIANominations } = languageData[languageSelected];
  const [AwardeeName, setAwardeeName] = useState<string>('');
  const [Organisation, setOrganisation] = useState<string>('');
  const [Location, setLocation] = useState<string>('');
  const [PictureUrl, setPictureUrl] = useState<string>('');
  const [PictureDetails, setPictureDetails] = useState<File>();
  const [UploadedImage, setUploadedImage] = useState<any>();
  const [VideoUrl, setVideoUrl] = useState<string>('');
  const [Notes, setNotes] = useState<string>('');
  const [openImageSizeAlert, setopenImageSizeAlert] = React.useState(false);
  const [imageDetails, setImageDetails] = useState<string>();
  const [updatedawardeeLists, setUpdatedAwardeeList] = useState<any>(null);
  const [openAddAwardee, setOpenForAddAwardee] = React.useState(false);
  const [cancelIcon, setCancelIcon] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const[disableAwardeeSubmit,setDisableAwardeeSubmit]=React.useState(true);

  // Handlers

  const AddAwardeeButtonHandler = () => {
    const formData = new FormData();
    formData.append("awardeeImageFile", PictureUrl);
    formData.append("AwardeeName", AwardeeName);
    formData.append("Organization", Organisation);
    formData.append("Location", Location);
    formData.append("VideoLink", VideoUrl);
    formData.append("Notes", Notes);
    addAwardeeDetails(formData).then((addAwardeeResponse: any) => {
      if (addAwardeeResponse) {
        setAwardeeName('');
        setLocation('');
        setOrganisation('');
        setNotes('');
        setVideoUrl('');
        setImageDetails('');
        setImageDetails(undefined);
        Setcount((count: number) => count + 1);
        //setAlertTitle(searchBox.error)
        setUpdatedAwardeeList(updatedawardeeLists);
        setCancelIcon(false);
        setAlertContent('Awardee added successfully!');
        setAlert(true);  
        setAlertType('success');
        setTimeout(() => { setAlert(false); }, 4000);
        appInsights.trackEvent({name:"NewAwardeeAdded",properties:{CorrelationId:getcorrelationId(),AccountIdentifier: getUserGraphId()}}) 
      }

    });

  }
  const AddAwardeehandleClickOpen = () => {
    setOpenForAddAwardee(true);
  };
  useEffect(() => {
    if((AwardeeName.length>0)&&(PictureUrl!='')&&(Organisation.length>0)&&(Location.length>0)&&(VideoUrl.length>0))
    {
  setDisableAwardeeSubmit(false);
    }
    else{
      setDisableAwardeeSubmit(true);
    }
    
  }, [AwardeeName,PictureUrl,Organisation,Location,VideoUrl])
    function AddAwardee() {
      setOpenForAddAwardee(false);
      AddAwardeeButtonHandler();
    }
    const handleClose = () => {
      setOpenForAddAwardee(false);
      setDisableAwardeeSubmit(true);
      setAwardeeName('');
      setLocation('');
      setOrganisation('');
      setNotes('');
      setVideoUrl('');
      setImageDetails('');
      setCancelIcon(false);
      setImageDetails(undefined);
      setopenImageSizeAlert(false);
    };
    const ImageSizeAlerClickClose = () => {
      setopenImageSizeAlert(false);
    };
  return (
    <React.Fragment>
<Container maxWidth={"xl"} >
{alert && <NotificationAlert state={alert} notificationMessage={alertContent} alertType={alertType}/>}
        <div className={styles.adminPage}>
          <h2 className={styles.headerBold}>Add System Awardee</h2>

          <h2 className={styles.header}>Enter Awardee's details here </h2>
          <hr />
          <form >
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} style={{width:'50vw'}}>
              <Grid item xs={6}>
                <TextField required className={styles.textFieldColor} inputProps={{ maxLength: 100 }} id="outlined-basic" label="Awardee's Name" variant="outlined" value={AwardeeName} onChange={e => setAwardeeName(e.target.value)} />
              </Grid>
              <Grid item xs={6}>
                <TextField required className={styles.textFieldColor} inputProps={{ maxLength: 100 }} id="outlined-basic" label="Organisation's Name" variant="outlined" value={Organisation} onChange={e => setOrganisation(e.target.value)} /> </Grid>
              <Grid item xs={6}>
                <TextField  required className={styles.textFieldColor} inputProps={{ maxLength: 100 }} id="outlined-basic" label="Location" variant="outlined" value={Location} onChange={e => setLocation(e.target.value)} />            </Grid>
              <Grid item xs={6}>
                <TextField required className={styles.textFieldColor} inputProps={{ maxLength: 2000 }} id="outlined-basic" label="Video Url" variant="outlined" value={VideoUrl} onChange={e => setVideoUrl(e.target.value)} />
              </Grid>

              <Grid item xs={12} sm={6}>
              <div style={{display:"flex",flexDirection:"row"}}>
                  {cancelIcon ? "" : ""}
                  <div></div>
                  <TextField required className={styles.textFieldColor} id="outlined-basic"  disabled={true} value={imageDetails!=undefined?imageDetails:"Upload Picture (Max 2MB)*"}  variant="outlined"
                    InputProps={{ endAdornment: cancelIcon?<CancelOutlinedIcon onClick={setPictureURLValue} style={{cursor: "pointer"}} />:""}} 
                    InputLabelProps = {
                      {
                         shrink: !!cancelIcon
                      }
                   }
                    />
                  <input
                    accept="image/jpg, image/jpeg,image/png"
                    //className={classes.input}
                    style={{ display: 'none' }}
                    id="raised-button-file"
                    multiple={false}
                    type="file"
                    onChange={e =>handleFileChange(e)}
                    onClick={(event:any)=> { 
                      event.currentTarget.value = null
                 }}
                  />
                  <label htmlFor="raised-button-file">
                    <IconButton color="primary"  component="span" >

                      <FileUploadIcon sx={{ fontSize: 30 }}/>

                    </IconButton>
                  </label>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField className={styles.textFieldColor} inputProps={{ maxLength: 2000 }} id="outlined-basic" label="Notes" variant="outlined" value={Notes} onChange={e => setNotes(e.target.value)} />
              </Grid>
            </Grid>

          </form>

            <Dialog
                open={Imagestate}
                onClose={handleShowDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
              <DialogContent style={{width:"400px",height:"370px",backgroundColor:'white'}}>
                <div style={{display:'flex', justifyContent:'space-between', flexDirection:'column'}}>
                  <div style={{width:"400px", height:"300px", position:'relative'}}>
                    <Cropper
                    disableAutomaticStylesInjection={false}
                    image={UploadedImage}
                    crop={crop}
                    rotation={rotation}
                    zoom={typeof zoom === 'number' ? zoom : 0}
                    aspect={3/4}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}/>
                  </div>
                    <div style={{marginTop:"10px", width:"400px", height:"50px", display:'flex', justifyContent:'space-between', flexDirection:'row', position:'relative'}}>
                      <div>
                        <Button
                        onClick={showCroppedImage}
                        variant="contained"
                        color="primary"
                        style={{flexShrink: 0}}>Show
                        </Button>
                      </div>
                      <div>
                      <Slider
                        value={typeof zoom === 'number' ? zoom : 0}
                        min={1}
                        max={3}
                        step={0.1}
                        aria-labelledby="Zoom"
                        onChange={handleZoom}
                        style={{width:"200px", marginBottom:'0'}}/>
                        <Typography style={{textIndent:'70px', fontWeight:'bold', color:'#00338e', marginTop:'0'}}>Zoom</Typography>
                      </div>
                      <div>
                        <Button  color="primary"variant="contained" onClick={saveCroppedImage} autoFocus 
                        style={{}} >Save
                        </Button>
                      </div>
                    </div>
                  <ImgDialog img={croppedImage} onClose={onClose}/>
                </div>
              </DialogContent>
            </Dialog>

          < div className={styles.awardeePopup}>
            <Button variant="outlined" className={disableAwardeeSubmit?styles.AddAwardeeDisabledBttn: styles.AddAwardeeBttn} disabled={disableAwardeeSubmit} onClick={AddAwardeehandleClickOpen}>Submit</Button>
             <Dialog
              open={openAddAwardee}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title" style={{ backgroundColor: '#00338e', fontFamily: 'barlow', color: '#FFFFFF' }}>
                {"Add Awardee"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to add this person as Awardee for the year {(new Date().getFullYear())}?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
              <Button className={styles.messageBoxEditor} onClick={AddAwardee} autoFocus>
                  Yes
                </Button>
                <Button className={styles.messageBoxEditor} onClick={handleClose}>No</Button>
              </DialogActions>
            </Dialog>
             {/* File Size alert */}
             <Dialog
              open={openImageSizeAlert}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                 Image size is too large. Upload an Image less than 2 MB!
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button className={styles.messageBoxEditor} onClick={ImageSizeAlerClickClose} autoFocus>
                  Ok
                </Button>
              </DialogActions>
            </Dialog>

            
          </div>
          <br />
          <h2 className={styles.header}>Awardees</h2>
            <hr />
          <div style={{ height: 400, width: '100%' }}>
            <DataGrid
              rows={updatedawardeeLists}
              columns={columns}
              pageSize={5}
              className={classes.root}
              rowsPerPageOptions={[5]}
              disableSelectionOnClick={true}
            />
          </div>
        </div>
        <br />
        <div>
          </div>
      </Container>
    </React.Fragment>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      border: 0,
      fontFamily: 'Barlow !important',
      backgroundColor: '#FFFFFF',

      '& .MuiDataGrid-cell:hover': {
        color: '#00338e',
      },
      '& .MuiDataGrid-columnHeader': {
        color: '#FFFFFF',
        backgroundColor: '#00338e',
        fontSize: 'calc(5px + 2vmin)',
        '& .MuiCheckbox-root svg path': {
          color: 'white',
        }
      },
      '& .MuiDataGrid-columnHeadersInner': {
        backgroundColor: '#00338e'
      },
      '& .MuiDataGrid-cell': {
        fontSize: 'calc(2px + 2vmin)'
      },
      '& .MuiCheckbox-root svg path': {
        color: '#00338e',
      }
    },cropContainer: {
      position: 'relative',
      width: 500,
      height: 200,
      background: '#333'  },
    cropButton: {
      flexShrink: 0,
      marginLeft: 16,
    },
    controls: {
      padding: 16,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
        alignItems: 'center',
      },
    },
    sliderContainer: {
      display: 'flex',
      flex: '1',
      alignItems: 'center',
    },
    sliderLabel: {
      [theme.breakpoints.down('xs')]: {
        minWidth: 65,
      },
    },
    slider: {
      padding: '22px 0px',
      marginLeft: 32,
      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
        alignItems: 'center',
        margin: '0 16px',
      },
    },
  })
);

export default AddAwardee;